"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _hoisted_1 = {
    id: "CountryTestRegistrationForm",
    class: "container"
};
const _hoisted_2 = { id: "ResultFormWrapper" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_1.createElementVNode)("div", { class: "row FormHeader" }, [
    /*#__PURE__*/ (0, vue_1.createElementVNode)("h2", null, "Your result is ready!"),
    /*#__PURE__*/ (0, vue_1.createElementVNode)("p", null, "Nearly done! Create an account or log in to view your personal test results")
], -1 /* HOISTED */);
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "AuthContainer" };
const _hoisted_6 = ["data-portal-type"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            _hoisted_3,
            (0, vue_1.createElementVNode)("div", _hoisted_4, [
                (0, vue_1.createElementVNode)("div", _hoisted_5, [
                    (0, vue_1.createElementVNode)("div", {
                        class: "AuthPlaceholder",
                        "data-layout": "MainYolo",
                        "data-referrer": "CountryTest",
                        "data-portal-type": _ctx.portalType
                    }, null, 8 /* PROPS */, _hoisted_6)
                ])
            ])
        ])
    ]));
}
exports.render = render;
